import moment from 'moment';
import React from "react";
import { Popover } from "antd";
import { useSelector } from 'react-redux';

const universalSorter = (valueA, valueB, profile) => {
    const extractText = (val) => {
        if (React.isValidElement(val)) {
            val = val.props?.children ?? '';
        }
        if (Array.isArray(val)) {
            val = val.map(child => {
                if (React.isValidElement(child)) {
                    return child.props?.children ?? '';
                }
                return child;
            }).join(' ');
        }
        if (typeof val === 'number') return val;
        if (typeof val === 'string') {
            const trimmed = val.trim();
            if (profile?.dateFormate && moment(trimmed, profile.dateFormate, true).isValid()) {
                return moment(trimmed, profile.dateFormate, true).toDate().getTime();
            }
            const cleaned = trimmed
                .replace(/^[^\d-]+/, '')
                .replace(/,/g, '')
                .replace(/\s+/g, '');
            const numberMatch = cleaned.match(/^(\d+(\.\d+)?)/);
            if (numberMatch) {
                return parseFloat(numberMatch[0]);
            }
            return trimmed.toLowerCase();
        }
        return '';
    };
    const a = extractText(valueA);
    const b = extractText(valueB);
    if (typeof a === 'number' && typeof b === 'number') {
        return a - b;
    }
    return String(a).localeCompare(String(b), undefined, { numeric: true });
};
export const generateDynamicColumns = (checkboxValues, ViewDetailPage, currencySettings, sortedInfo) => {
    let columns = [];
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    if (checkboxValues !== undefined) {
        columns = checkboxValues
            .filter((item) => item.isChecked)
            .map((item) => {
                const columnConfig = {
                    title: (item.FieldValue === "forecastedvalue" || item.FieldValue === "dealvalue" || item.FieldValue === "dealprofit" || item.FieldValue === 'grossdealvalue') ? `${item.name} (${currencySettings?.currency})` : ((item.FieldValue === "expecteddealmargin" || item.FieldValue === "winprobability" || item.FieldValue === "discountprecentage") ? `${item.name} %` : item.name),
                    dataIndex: item.FieldValue,
                    key: item.FieldValue,
                    sortDirections: ['ascend', 'descend'],
                    sortOrder: sortedInfo?.column?.dataIndex === item.FieldValue ? sortedInfo?.order : null
                };
                switch (item.FieldValue) {
                    case 'contactperson':
                        columnConfig.onCell = () => ({
                            onClick: (e) => {
                                e.stopPropagation();
                            },
                        });
                        break;
                    case 'competition':
                        columnConfig.onCell = () => ({
                            onClick: (e) => {
                                e.stopPropagation();
                            },
                        });
                        // columnConfig.sorter = (a, b) => {
                        //     const extractText = (element) => {
                        //         return element && element.props && element.props.children !== undefined
                        //             ? String(element.props.children)
                        //             : '';
                        //     };
                        //     const contactpersonA = extractText(a[item.FieldValue]);
                        //     const contactpersonB = extractText(b[item.FieldValue]);
                        //     return contactpersonA.localeCompare(contactpersonB);
                        // };
                        // columnConfig.render = (relatedToArray) => (
                        //     <span>
                        //         {Array.isArray(relatedToArray.props.children) ? (
                        //             relatedToArray.props.children.map((item, index) => (
                        //                 <span key={index}>
                        //                     {item}
                        //                     {index !== relatedToArray.props.children.length - 1 && ', '}
                        //                 </span>
                        //             ))
                        //         ) : (
                        //             relatedToArray.props.children
                        //         )}
                        //     </span>
                        // );
                        break;
                    case 'dealowner':
                        columnConfig.onCell = (record) => ({
                            onClick: (e) => {
                                e.stopPropagation();
                                if (Role === "Administrator" || profile.userId === record.userId) {
                                    ViewDetailPage(record.userId, "USER")
                                }
                            },
                        });
                        columnConfig.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.dealowner.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    case 'accountname':
                        columnConfig.onCell = (record) => ({
                            onClick: (e) => {
                                e.stopPropagation();
                                if (record?.LinkAccount) {
                                    ViewDetailPage(record.accountID, "ACCOUNT")
                                }
                            },
                        });
                        columnConfig.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.accountname.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    case 'dealname':
                        columnConfig.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.dealname.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    default:
                        columnConfig.sorter = (a, b) => {
                            const valueA = a[item.FieldValue]?.props?.children || '';
                            const valueB = b[item.FieldValue]?.props?.children || '';
                            return universalSorter(valueA, valueB, profile);
                        };
                        break;
                }
                return columnConfig;
            });
    }
    return columns;
};

export const generateUsersTableData = (exportData, currencySettings, ViewDetailPage) => {
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const usersTableData = [];
    if (exportData) {
        exportData.forEach((deal, key) => {
            usersTableData.push({
                LinkAccount: deal.accountPermission,
                DealDataForPermission: deal,
                PipelineCheck: deal.pipelineStage,
                SharingData: deal?.sharingPermission?.sharePermission,
                sharingid: deal.fromId,
                userId: deal.deal_owner,
                accountID: deal.account_id,
                key: deal.deals_id,
                no: key + 1,
                dealname: (<div className="user-info_image table_list_clicks">
                    {deal.deals_id &&
                        (deal.deal_profile !== null && deal.deal_profile !== undefined && deal.deal_profile !== "" ?
                            < figure >
                                <img style={{ width: "30px", height: "30px" }} src={deal.deal_profile} alt="" />
                            </figure>
                            :
                            <span className='list_span_Tag DealIcon'>
                                {deal.deal_name && deal.deal_name.slice(0, 1)?.toUpperCase()}
                            </span>)
                    }
                    {deal.deals_id &&
                        <figcaption>
                            <div>
                                {deal.deal_name}
                            </div>
                            <div className='entityemail'>
                                {deal.pipelineStage}
                            </div>
                        </figcaption >
                    }
                </div >),
                dealowner: (<div className={`user-info_image ${(Role === "Administrator" || profile.userId === deal.deal_owner) && "ListNavigate"}`}>
                    {deal.deal_owner &&
                        (deal.userProfilePic !== null && deal.userProfilePic !== undefined && deal.userProfilePic !== "" ?
                            < figure >
                                <img style={{ width: "30px", height: "30px" }} src={deal.userProfilePic} alt="" />
                            </figure>
                            :
                            <span className='list_span_Tag UserIcon'>
                                {deal.userFirstName && deal.userFirstName.slice(0, 1)?.toUpperCase()}
                            </span>)
                    }
                    {deal.deal_owner &&
                        <figcaption>
                            <div>
                                {`${deal.userFirstName} ${deal.userLastName}`}
                            </div>
                            <div className='entityemail'>
                                {deal.dealOwner}
                            </div>
                        </figcaption>
                    }
                </div>),
                accountname: (<div className={`user-info_image ${deal.accountPermission && "ListNavigate"}`}>
                    {deal.account_id &&
                        (deal.account_profile !== null && deal.account_profile !== undefined && deal.account_profile !== "" ?
                            < figure >
                                <img style={{ width: "30px", height: "30px" }} src={deal.account_profile} alt="" />
                            </figure>
                            :
                            <span className='list_span_Tag AccountIcon'>
                                {deal.account_name && deal.account_name.slice(0, 1)?.toUpperCase()}
                            </span>)
                    }
                    {deal.account_id &&
                        <figcaption><div>
                            {deal.account_name}
                        </div>
                            <div className='entityemail'>
                                {deal.account_number}
                            </div>
                        </figcaption>
                    }
                </div>),
                competition: (
                    <div className='table_list_clicks' style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: "nowrap", // Keeps all items in a row
                        minWidth: "max-content", // Ensures it grows as needed
                    }}>
                        {deal.competitiondata && deal.competitiondata.length > 0 && (
                            <>
                                {deal.competitiondata.slice(0, 3).map((item, index) => {
                                    if (!item.competitionName) {
                                        return null;
                                    }
                                    const EntiryIds = item?.competitionId
                                    const permission = item.competitionPermission
                                    return (
                                        <div
                                            title={item?.competitionName}
                                            key={index}
                                            role="button"
                                            tabIndex={0}
                                            style={{ cursor: !permission && "not-allowed" }}
                                            onKeyDown={(event) => {
                                                if (permission && (event.key === 'Enter' || event.key === ' ')) {
                                                    ViewDetailPage(EntiryIds, "ACCOUNT")
                                                }
                                            }}
                                            onClick={permission ? () => ViewDetailPage(EntiryIds, "ACCOUNT") : undefined}
                                        >
                                            {item?.competitionProfile ? (
                                                <span className="image_icon OverLap_images">
                                                    <img style={{
                                                        width: '30px',
                                                        height: '30px',
                                                        borderRadius: '50%',
                                                    }}
                                                        src={item?.competitionProfile} alt="" />
                                                </span>
                                            ) : (
                                                <span className="image_icon OverLap_images AccountIcon" >
                                                    {item?.competitionName.slice(0, 1)?.toUpperCase()}
                                                </span>
                                            )}
                                        </div>);
                                })}
                                {deal.competitiondata.length > 3 && (
                                    <Popover
                                        placement="bottomLeft"
                                        trigger="hover"
                                        content={
                                            <div
                                                style={{
                                                    maxHeight: "200px",
                                                    overflowY: "auto",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "8px",
                                                    padding: "4px 0",
                                                }}
                                            >
                                                {deal.competitiondata.slice(3).map((item, index) => {
                                                    if (!item.competitionName) {
                                                        return null;
                                                    }
                                                    const EntiryIds = item?.competitionId
                                                    const permission = item.competitionPermission
                                                    return (
                                                        <div
                                                            title={item?.competitionName}
                                                            key={index}
                                                            role="button"
                                                            tabIndex={0}
                                                            style={{ cursor: permission ? "pointer" : "not-allowed", display: "flex", alignItems: "center", gap: "8px", marginBottom: 10 }}
                                                            onKeyDown={(event) => {
                                                                if (permission && (event.key === 'Enter' || event.key === ' ')) {
                                                                    ViewDetailPage(EntiryIds, "ACCOUNT")
                                                                }
                                                            }}
                                                            onClick={permission ? () => ViewDetailPage(EntiryIds, "ACCOUNT") : undefined}

                                                        >
                                                            {item?.competitionProfile ? (
                                                                <img
                                                                    src={item?.competitionProfile}
                                                                    alt={item?.competitionName}
                                                                    style={{
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        borderRadius: '50%',
                                                                    }}
                                                                />
                                                            ) : (
                                                                <span className="image_icon AccountIcon">
                                                                    {item?.competitionName.slice(0, 1)?.toUpperCase()}
                                                                </span>
                                                            )}
                                                            <span>{item?.competitionName}</span>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        }
                                    >
                                        <span
                                            style={{
                                                marginLeft: "25px",
                                                fontSize: "13px",
                                                fontWeight: 500,
                                                color: "#1677ff",
                                                cursor: "pointer",
                                            }}
                                        >
                                            +{deal.competitiondata.length - 3} more
                                        </span>
                                    </Popover>
                                )}
                            </>
                        )}
                    </div>
                ),
                contactperson: (
                    <div className='table_list_clicks' style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: "nowrap", // Keeps all items in a row
                        minWidth: "max-content", // Ensures it grows as needed
                    }}>
                        {deal.contactNames && deal.contactNames.length > 0 && (<>
                            {deal.contactNames.slice(0, 3).map((item, index) => {
                                const permission = item?.contactPersonPermission
                                return (
                                    <div
                                        title={item?.contactPersonName}
                                        key={index}
                                        role="button"
                                        tabIndex={0}
                                        style={{ cursor: !permission && "not-allowed" }}
                                        onKeyDown={(event) => {
                                            if (permission && (event.key === 'Enter' || event.key === ' ')) {
                                                ViewDetailPage(item?.contactPersonId, "CONTACT")
                                            }
                                        }}
                                        onClick={permission ? () => ViewDetailPage(item?.contactPersonId, "CONTACT") : undefined}
                                    >
                                        {item?.contactPersonProfileic ? (
                                            <span className="image_icon OverLap_images">
                                                <img style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    borderRadius: '50%',
                                                }}
                                                    src={item?.contactPersonProfileic} alt="" />
                                            </span>
                                        ) : (
                                            <span
                                                className="image_icon OverLap_images ContactIcon"
                                            // style={{
                                            //     display: 'inline-block',
                                            //     width: '30px',
                                            //     height: '30px',
                                            //     borderRadius: '50%',
                                            //     backgroundColor: '#FFA500', // Or any fallback color
                                            //     textAlign: 'center',
                                            //     lineHeight: '30px',
                                            //     fontSize: '14px',
                                            //     fontWeight: 'bold',
                                            // }}
                                            >
                                                {item?.contactPersonName.slice(0, 1)?.toUpperCase()}
                                            </span>
                                        )}
                                    </div>
                                );
                            })}
                            {deal.contactNames.length > 3 && (
                                <Popover
                                    placement="bottomLeft"
                                    trigger="hover"
                                    content={
                                        <div
                                            style={{
                                                maxHeight: "200px",
                                                overflowY: "auto",
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "8px",
                                                padding: "4px 0",
                                            }}
                                        >
                                            {deal.contactNames.slice(3).map((item, index) => {
                                                const permission = item?.contactPersonPermission
                                                return (<div
                                                    title={item?.contactPersonName}
                                                    key={index}
                                                    role="button"
                                                    tabIndex={0}
                                                    style={{ cursor: permission ? "pointer" : "not-allowed", display: "flex", alignItems: "center", gap: "8px", marginBottom: 10 }}
                                                    onKeyDown={(event) => {
                                                        if (permission && (event.key === 'Enter' || event.key === ' ')) {
                                                            ViewDetailPage(item?.contactPersonId, "CONTACT")
                                                        }
                                                    }}
                                                    onClick={permission ? () => ViewDetailPage(item?.contactPersonId, "CONTACT") : undefined}
                                                >
                                                    {item?.contactPersonProfileic ? (
                                                        <img
                                                            src={item?.contactPersonProfileic}
                                                            alt={item?.contactPersonName}
                                                            style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                borderRadius: '50%',
                                                            }}
                                                        />
                                                    ) : (
                                                        <span className="image_icon ContactIcon">
                                                            {item?.contactPersonName.slice(0, 1)?.toUpperCase()}
                                                        </span>
                                                    )}
                                                    <span>{item?.contactPersonName}</span>
                                                </div>
                                                )
                                            })}
                                        </div>
                                    }
                                >
                                    <span
                                        style={{
                                            marginLeft: "25px",
                                            fontSize: "13px",
                                            fontWeight: 500,
                                            color: "#1677ff",
                                            cursor: "pointer",
                                        }}
                                    >
                                        +{deal.contactNames.length - 3} more
                                    </span>
                                </Popover>
                            )}
                        </>
                        )}
                    </div>
                ),
                priority: (<div className={`table_list_clicks status-text Task${deal.priority_name}`}>{deal.priority_name}</div>),
                dealtype: (<div className='table_list_clicks'>{deal.deal_type_name}</div>),
                subtype: (<div className='table_list_clicks'>{deal.subtype}</div>),
                commitstatus: (<div className='table_list_clicks'>{deal.commit_status}</div>),
                pipelinestage: (<div className={`table_list_clicks status-text PipeLine${deal.pipeline_stage}`}>{deal.pipelineStage}</div>),
                expecteddealmargin: (<div className='table_list_clicks'>{deal.expected_deal_length !== undefined && deal.expected_deal_length !== null && `% ${deal.expected_deal_length}`}</div>),
                winprobability: (<div className='table_list_clicks'>{deal.win_probability !== undefined && deal.win_probability !== null && `% ${deal.win_probability}`}</div>),
                forecastedvalue: (<div className='table_list_clicks'>{`${currencySettings?.symbol} ${deal?.forecasted_value?.toLocaleString()}`}</div>),
                dealvalue: (<div className='table_list_clicks'>{`${currencySettings?.symbol} ${deal?.deal_value?.toLocaleString()}`}</div>),
                dealprofit: (<div className='table_list_clicks'>{`${currencySettings?.symbol} ${deal?.deal_profit?.toLocaleString()}`}</div>),
                grossdealvalue: (<div className='table_list_clicks'>{`${currencySettings?.symbol} ${deal?.gross_deal_value?.toLocaleString()}`}</div>),
                discountprecentage: (<div className='table_list_clicks'>{deal.discount_percentage !== undefined && deal.discount_percentage !== null && `% ${deal.discount_percentage}`}</div>),
                createdby: (<div className='table_list_clicks'>{deal?.created_at}</div>),
                modifiedby: (<div className='table_list_clicks'>{deal?.modified_at}</div>),
                revenuestartdate: (<div className='table_list_clicks'>{deal?.revenue_start_date}</div>),
                revenueenddate: (<div className='table_list_clicks'>{deal?.revenue_end_date}</div>),
                expectedclosuredate: (<div className='table_list_clicks'>{deal?.expected_closure_date}</div>),
                wonReason: (<div className='table_list_clicks'>{deal.dealWonReasonName}</div>),
                lostReason: (<div className='table_list_clicks'>{deal.dealLostReasonName}</div>),
                holdReason: (<div className='table_list_clicks'>{deal.dealHoldReasonName}</div>),
                dealMargin: (<div className='table_list_clicks'>{deal.actual_deal_margin !== undefined && deal.actual_deal_margin !== null && `% ${deal.actual_deal_margin}`}</div>),
                restartDate: (<div className='table_list_clicks'>{deal?.deal_restart_date}</div>),
                holdDate: (<div className='table_list_clicks'>{deal?.deal_hold_date}</div>),
                closureDate: (<div className='table_list_clicks'>{deal?.actual_closer_date}</div>),
                lostDate: (<div className='table_list_clicks'>{deal?.deal_lost_date}</div>),
                Description: (<div className='table_list_clicks'>
                    {deal.deal_description ? `${deal.deal_description.substring(0, 50)}...` : deal.deal_description}
                </div>),
                dealScore: (
                    <div className='table_list_clicks'>
                        {Number(deal?.deal_score)?.toFixed(2)}
                    </div>
                ),
            });
        });
    }
    return usersTableData;
};
